export const CLEAR_JOBS_DATA = 'CLEAR_JOBS_DATA';


//──── Filters ───────────────────────────────────────────────────────────────────────────
export const JOBS_UPDATE_FILTERS = 'JOBS_UPDATE_FILTERS';
